import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook personalizado para gestión de etapas del lead
 * @param {Object} detallesLead - Detalles del lead actual
 * @param {Function} setDetallesLead - Actualiza los detalles del lead
 * @param {Array} contactos - Lista de contactos
 * @param {Function} setContactos - Actualiza la lista de contactos
 * @param {Function} GuardarComentario - Función para guardar comentarios
 * @param {Function} guardarNotificacion - Función para guardar notificaciones
 * @param {Function} crearObjAction - Función para crear objeto de acción
 * @returns {Object} Funciones y estados para gestión de etapas
 */
export const useLeadStage = (
    detallesLead,
    setDetallesLead,
    contactos,
    setContactos,
    GuardarComentario,
    guardarNotificacion,
    crearObjAction
) => {
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [motivoNoInteresado, setMotivoNoInteresado] = useState('');
    const [habilitarBtnGuardar, setHabilitarBtnGuardar] = useState(true);
    const [editarEtapaModal, setEditarEtapaModal] = useState(false);

    /**
     * Cambia la etapa del lead
     * @param {Event} event - Evento del select
     * @param {Function} setShowEtapaNoInteresadoModal - Mostrar modal de no interesado
     * @param {Function} setShowEtapaClienteGanadoModal - Mostrar modal de cliente ganado
     * @param {Function} setIdLead - Establecer ID del lead
     * @param {Function} setvNombreEtapa - Establecer nombre de etapa
     * @param {Function} setEditarEtapaModal - Controlar edición de etapa
     * @param {Array} leadsVinculados - Lista de leads vinculados
     */
    const CambiarEtapa = async (
        event,
        setShowEtapaNoInteresadoModal,
        setShowEtapaClienteGanadoModal,
        setIdLead,
        setvNombreEtapa,
        setEditarEtapaModal,
        leadsVinculados
    ) => {
        const idEtapaLead = detallesLead.idEtapa;
        const idEtapaTarget = event.target.value;

        if (idEtapaLead == 6 && idEtapaTarget == 4) {
            showErrorToast('La etapa del cliente es Recompra en proceso, no es posible cambiarla a cliente ganado');
            return;
        }

        if (event.target.value == 5) {
            setMotivoNoInteresado("");
            setShowEtapaNoInteresadoModal(true);
            setIdLead(detallesLead.idLead);
            setHabilitarBtnGuardar(true);
        } else if (event.target.value == 4 && detallesLead.idClienteAkasia == null) {
            setvNombreEtapa(detallesLead.vNombreEtapa);
            setIdLead(detallesLead.idLead);
            setShowEtapaClienteGanadoModal(true);
        } else {
            const jDataSend = {
                idEtapa: event.target.value,
                idLead: detallesLead.idLead
            };

            const response = await fetch("/api/leads/changeEtapaLead/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    const detalles = JSON.parse(data.detalles);

                    GuardarComentario(
                        "Modificó etapa de <b>" + detallesLead.vNombreEtapa + "</b> a <b>" + detalles[0].vNombreEtapa + "</b>",
                        "2",
                        detallesLead.idLead
                    );

                    if (contactos !== null && typeof contactos !== 'undefined') {
                        const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                        if (currentLeadIndex == -1) {
                            const detalleslead_Copy = {
                                ...detallesLead,
                                idEtapa: detalles[0].idEtapa,
                                vNombreEtapa: detalles[0].vNombreEtapa
                            };
                            setContactos([detalleslead_Copy, ...contactos]);
                        } else {
                            contactos[currentLeadIndex].iDaysDiff = 0;
                            contactos[currentLeadIndex].idEtapa = detalles[0].idEtapa;
                            contactos[currentLeadIndex].vNombreEtapa = detalles[0].vNombreEtapa;
                        }
                    }

                    if (leadsVinculados !== null && typeof leadsVinculados !== 'undefined') {
                        const currentLeadEditadoIndex = leadsVinculados.findIndex((lead) => lead.idLead === detallesLead.idLead);
                        if (currentLeadEditadoIndex >= 0) {
                            leadsVinculados[currentLeadEditadoIndex].idEtapa = detalles[0].idEtapa;
                            leadsVinculados[currentLeadEditadoIndex].vNombreEtapa = detalles[0].vNombreEtapa;
                        }
                    }

                    if (idUsuario != detallesLead.idUsuario) {
                        const objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                        guardarNotificacion(
                            "Etapa de lead cambiada",
                            "<b> " + nombreCompleto + "</b> modificó la etapa del lead <b>#" + detallesLead.idLead + "</b> a: <i> '" + detalles[0].vNombreEtapa.substring(0, 7) + "...'</i>",
                            detallesLead.idUsuario,
                            objToActionString,
                            2
                        );
                    }

                    setDetallesLead({
                        ...detallesLead,
                        idEtapa: detalles[0].idEtapa,
                        vNombreEtapa: detalles[0].vNombreEtapa
                    });

                    setEditarEtapaModal(false);
                    showSuccessToast("Cambio de etapa exitoso");
                } else {
                    setHabilitarBtnGuardar(true);
                    showErrorToast(data.vMessage);
                }
            } else {
                setHabilitarBtnGuardar(true);
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    window.location.href = "";
                }
            }
        }
    };

    /**
     * Establece la etapa como "No Interesado"
     * @param {number} idLead - ID del lead
     * @param {Function} setShowEtapaNoInteresadoModal - Cerrar modal
     * @param {Function} setEditarEtapaModal - Cerrar edición de etapa
     * @param {Array} leadsVinculados - Lista de leads vinculados
     */
    const etapaNoInteresado = async (idLead, setShowEtapaNoInteresadoModal, setEditarEtapaModal, leadsVinculados) => {
        if (motivoNoInteresado.length > 5) {
            setHabilitarBtnGuardar(false);

            const jDataSend = {
                idEtapa: 5,
                idLead: idLead
            };

            const response = await fetch("/api/leads/changeEtapaLead/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    const detalles = JSON.parse(data.detalles);

                    GuardarComentario("<b class='badge badge-soft-danger'>Lead no interesado </b> " + motivoNoInteresado, 2, idLead);

                    if (idUsuario != detallesLead.idUsuario) {
                        const objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                        guardarNotificacion(
                            "Etapa de lead cambiada",
                            "<b> " + nombreCompleto + "</b> modificó la etapa del lead <b>#" + detallesLead.idLead + "</b> a: <i> 'No intere...'</i>",
                            detallesLead.idUsuario,
                            objToActionString,
                            2
                        );
                    }

                    setDetallesLead({
                        ...detallesLead,
                        idEtapa: detalles[0].idEtapa,
                        vNombreEtapa: detalles[0].vNombreEtapa
                    });

                    if (contactos !== null && typeof contactos !== 'undefined') {
                        const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === idLead);
                        if (currentLeadIndex >= 0) {
                            contactos[currentLeadIndex].iDaysDiff = 0;
                            contactos[currentLeadIndex].vNombreEtapa = detalles[0].vNombreEtapa;
                            contactos[currentLeadIndex].idEtapa = detalles[0].idEtapa;
                        }
                    }

                    if (leadsVinculados !== null && typeof leadsVinculados !== 'undefined') {
                        const currentLeadEditadoIndex = leadsVinculados.findIndex((lead) => lead.idLead === detallesLead.idLead);
                        if (currentLeadEditadoIndex >= 0) {
                            leadsVinculados[currentLeadEditadoIndex].idEtapa = detalles[0].idEtapa;
                            leadsVinculados[currentLeadEditadoIndex].vNombreEtapa = detalles[0].vNombreEtapa;
                        }
                    }

                    showSuccessToast("Cambio de etapa exitoso");
                    setShowEtapaNoInteresadoModal(false);
                    setEditarEtapaModal(false);
                } else {
                    setHabilitarBtnGuardar(true);
                    showErrorToast(data.vMessage);
                }
            } else {
                setHabilitarBtnGuardar(true);
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    window.location.href = "";
                }
            }
        } else {
            showErrorToast('Es obligatorio poner un motivo de no interesado');
        }
    };

    return {
        editarEtapaModal,
        setEditarEtapaModal,
        motivoNoInteresado,
        setMotivoNoInteresado,
        habilitarBtnGuardar,
        setHabilitarBtnGuardar,
        CambiarEtapa,
        etapaNoInteresado
    };
};
